import React from 'react';

import GenericMilestoneData from '../shared/GenericMilestoneData';

export default function SponsorMilestoneData(props) {
    return <GenericMilestoneData {...props} />;
}
